export default "__VITE_ASSET__C0_XeV7n__"